import { themeColors } from "../../../../themeColors";
/**
 * @file   src\mobile\components\Common\UserPlan\PaymentMethods.js
 * @brief  This file is responsible for showing payment methods list in mobile view
 * @date   April, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */
import React, { useEffect, useState } from "react";
import "../../../styles/clients.scss";
import {
  getCardIconForIntroduction,
  isDateInThePast,
} from "../../../../helpers/common";
import TopHeader from "../TopHeader";
import { ADD_PAY_METHOD, REVIEW_PLAN } from "../../../../constants/onBoarding";
import AddPaymentModalStripe from "./AddPaymentModalStripe";
import paymentMethodState from "../../../../appState/paymentMethodState";
import { usePremium } from "@/hooks";
import BackLinkButton from "../../../components/BackLinkButton";

const PaymentMethods = (props) => {
  const { updateCardParam, handlePageToggle } = props;
  useEffect(() => {
    document.body.classList.add("bg-offcanvas-fix");
  }, []);
  const [reload, setReload] = useState(0);
  const [showAddPaymentModal, setAddPaymentModal] = useState(false);
  const AddPaymentModalClose = () => setAddPaymentModal(false);
  const userPaymentMethods = paymentMethodState({ reload: reload });

  const { shouldToggleColor } = usePremium();

  const selectedCardId = props.selectedCardId;

  const handleRadioButtonChange = (paymentMethod) => {
    updateCardParam(paymentMethod);
    handlePageToggle({ activePage: REVIEW_PLAN });
  };

  return (
    <div className="gitcha-main-wrapper view-client-wrap select-payment-wrap pb-102">
      {showAddPaymentModal && (
        <AddPaymentModalStripe
          show={showAddPaymentModal}
          onHide={() => {
            AddPaymentModalClose();
          }}
          setReload={setReload}
          fromSubscriptionComponent={true}
        />
      )}
      <div className="content-wrapper content-wrapper-h-102">
        <TopHeader
          variant={"review"}
          outerClassname="bg-white"
          topClassName="header-brdr-btm w-100"
          bottomClassName="signup-header-txt clearfix"
        >
          <BackLinkButton
            role="button"
            variant="small"
            shouldToggleColor={shouldToggleColor}
            onClick={() => {
              handlePageToggle({ activePage: REVIEW_PLAN });
            }}
          />
          <span className={shouldToggleColor ? "heading-premium" : "heading"}>
            Edit Payment Method
          </span>
        </TopHeader>
        <div className="inner-layout-content-new bg-white">
          <div className="modal-choose-property mb-0">
            {userPaymentMethods &&
              userPaymentMethods.length > 0 &&
              userPaymentMethods?.map((paymentMethod) => {
                let expired = isDateInThePast(
                  paymentMethod?.Exp_Month,
                  paymentMethod?.Exp_Year,
                );
                return (
                  <label className="property-radio">
                    {!expired && (
                      <input
                        type="radio"
                        name="check-box-option"
                        id={paymentMethod?.CardId}
                        value={paymentMethod?.CardId}
                        checked={
                          paymentMethod?.Payment_Mode_Id == selectedCardId
                            ? true
                            : false
                        }
                        onClick={() => handleRadioButtonChange(paymentMethod)}
                      />
                    )}
                    <span className="bdrRadius-0">
                      <div className="card-icon">
                        {" "}
                        <img
                          src={getCardIconForIntroduction(paymentMethod?.Brand)}
                        />
                      </div>
                      <div className="card-name">
                        <h4>
                          {paymentMethod?.Brand} •••••••••••••
                          {paymentMethod?.Last4}{" "}
                        </h4>
                        {expired ? (
                          <p className="m-0">
                            Expired{" "}
                            {String(paymentMethod?.Exp_Month).padStart(2, "0")}/
                            {String(paymentMethod?.Exp_Year).slice(-2)}
                          </p>
                        ) : (
                          <p className="m-0">
                            Exp.{" "}
                            {String(paymentMethod?.Exp_Month).padStart(2, "0")}/
                            {String(paymentMethod?.Exp_Year).slice(-2)}
                          </p>
                        )}
                      </div>
                    </span>
                  </label>
                );
              })}
          </div>
        </div>
      </div>
      <div className="inner-layout-footer-new">
        <div className="inner-btm-fixed-nav">
          <div className="btn-wrap">
            <button
              type="button"
              className="btn btn-light w-100 btn-ico-flex"
              onClick={() => {
                handlePageToggle({ activePage: ADD_PAY_METHOD });
              }}
            >
              Add Debit/Credit Card <i className="add-ico"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentMethods;
